import React from 'react';
import { Row, Col, Form, InputGroup, FormControl } from 'react-bootstrap';

function PlateSelector({ plates, isMetric, handlePlateChange }) {

  return (
    <div className='barbell-rack-calc'>
    <Row>
      <Col xs={12}>
        <Form.Group controlId="plates">
          <Form.Label>Plates:</Form.Label>
          <div className="plate-selector-container">
            <div className="plate-selector-column">
              <InputGroup>
                <InputGroup.Text>{isMetric ? '20' : '45'}</InputGroup.Text>
                <FormControl
                  type="number"
                  name="45"
                  value={plates[isMetric ? '20' : '45']}
                  onChange={handlePlateChange}
                />
              </InputGroup>
              <br />
              <InputGroup>
                <InputGroup.Text>{isMetric ? '15' : '35'}</InputGroup.Text>
                <FormControl
                  type="number"
                  name="35"
                  value={plates[isMetric ? '15' : '35']}
                  onChange={handlePlateChange}
                />
              </InputGroup>
              <br />
              <InputGroup>
                <InputGroup.Text>{isMetric ? '10' : '25'}</InputGroup.Text>
                <FormControl
                  type="number"
                  name="25"
                  value={plates[isMetric ? '10' : '25']}
                  onChange={handlePlateChange}
                />
              </InputGroup>
            </div>
            <div className="plate-selector-column">
              <InputGroup>
                <InputGroup.Text>{isMetric ? '5' : '10'}</InputGroup.Text>
                <FormControl
                  type="number"
                  name="10"
                  value={plates[isMetric ? '5' : '10']}
                  onChange={handlePlateChange}
                />
              </InputGroup>
              <br />
              <InputGroup>
                <InputGroup.Text>{isMetric ? '2.5' : '5'}</InputGroup.Text>
                <FormControl
                  type="number"
                  name="5"
                  value={plates[isMetric ? '2.5' : '5']}
                  onChange={handlePlateChange}
                />
              </InputGroup>
              <br />
              <InputGroup>
                <InputGroup.Text>{isMetric ? '1.25' : '2.5'}</InputGroup.Text>
                <FormControl
                  type="number"
                  name="2.5"
                  value={plates[isMetric ? '1.25' : '2.5']}
                  onChange={handlePlateChange}
                />
              </InputGroup>
            </div>
          </div>
        </Form.Group>
      </Col>
    </Row>
    </div>
  );
}

export default PlateSelector;